export default "__VITE_ASSET__wqzsf4Km__"